'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var TableFooter$1 = require('../../../node_modules/@material-ui/core/esm/TableFooter/TableFooter.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var TableFooter = React__default["default"].forwardRef(function (_ref, ref) {
  var borders = _ref.borders,
      stickyColumn = _ref.stickyColumn,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ["borders", "stickyColumn", "children"]);

  return React__default["default"].createElement(TableFooter$1["default"], _extends["default"]({}, props, {
    ref: ref
  }), borders || stickyColumn ? React.Children.map(children, function (child) {
    return React.cloneElement(child, {
      borders: borders,
      stickyColumn: stickyColumn
    });
  }) : children);
});

module.exports = TableFooter;
